import React from "react";

import { useLocation } from "react-router-dom";

import { useCookies } from "react-cookie";

import CookieConsent from "./CookieConsent";

const withLocation = (Component) => (props) => {
  const location = useLocation();

  return <Component {...props} location={location} />;
};

const RouteChangeTracker = ({ location }) => {
  const [cookies] = useCookies(["cookie-consented"]);
  const [consented, setConsented] = React.useState(!GDPR());

  if (GDPR()) {
    return <CookieConsent setConsented={setConsented} />;
  }

  return <></>;
};

const GDPR = () => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  // var _tz = tz.guess();
  switch (timeZone) {
    case "America/Los_Angeles": // Should be opt-out, but in here because I'm lazy.
      return true;
    case "Europe/Vienna":
      return true;
    case "Europe/Brussels":
      return true;
    case "Europe/Sofia":
      return true;
    case "Europe/Zagreb":
      return true;
    case "Asia/Famagusta":
      return true;
    case "Asia/Nicosia":
      return true;
    case "Europe/Prague":
      return true;
    case "Europe/Copenhagen":
      return true;
    case "Europe/Tallinn":
      return true;
    case "Europe/Helsinki":
      return true;
    case "Europe/Paris":
      return true;
    case "Europe/Berlin":
      return true;
    case "Europe/Busingen":
      return true;
    case "Europe/Athens":
      return true;
    case "Europe/Budapest":
      return true;
    case "Europe/Dublin":
      return true;
    case "Europe/Rome":
      return true;
    case "Europe/Riga":
      return true;
    case "Europe/Vilnius":
      return true;
    case "Europe/Luxembourg":
      return true;
    case "Europe/Malta":
      return true;
    case "Europe/Amsterdam":
      return true;
    case "Europe/Warsaw":
      return true;
    case "Atlantic/Azores":
      return true;
    case "Atlantic/Madeira":
      return true;
    case "Europe/Lisbon":
      return true;
    case "Europe/Bucharest":
      return true;
    case "Europe/Bratislava":
      return true;
    case "Europe/Ljubljana":
      return true;
    case "Africa/Ceuta":
      return true;
    case "Atlantic/Canary":
      return true;
    case "Europe/Madrid":
      return true;
    case "Europe/Stockholm":
      return true;
    default:
      return false;
  }
};

export default withLocation(RouteChangeTracker);
